import { frontendURL } from '../../../helper/URLHelper';

const InstagramMediaReports = () =>
  import(
    '../settings/reports/InstagramMediaReports.vue'
  );

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/instagram-monitor'),
      name: 'instagram_monitor_index',
      component: InstagramMediaReports,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
